import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { FeaturedContentGridBlock } from "../../lib/storyblok/types/blocks/FeaturedContentGridBlock";
import FeaturedContentGridUi from "../../ui/FeaturedContentGrid";
import FeaturedContentItem from "../../ui/FeaturedContentGrid/components/FeaturedContentItem";
import { useRelations } from "../../lib/storyblok/useRelations";
import StoryblokImage from "../StoryblokImage";
import Button from "../../ui/Button";
import { useTranslation } from "next-i18next";
import { isForegroundImage } from "../../lib/utils/resolveStoryImage";
import { resolveSlug } from "../../lib/utils/resolveSlug";
import { isValidImageData } from "../../lib/utils/imageUtils";

const FeaturedContentGrid: StoryblokBlockComponent<
  FeaturedContentGridBlock
> = ({ items }) => {
  const { getRelation } = useRelations();
  const { t } = useTranslation();

  if (items) {
    return (
      <FeaturedContentGridUi>
        {items &&
          items.map((item, i) => {
            const story = getRelation(item.item);
            if (story) {
              const { uuid, content, name, full_slug } = story;
              return (
                <FeaturedContentItem
                  key={uuid}
                  productName={name}
                  title={name}
                  preamble={content.description}
                  backgroundImage={
                    isValidImageData(content.image) && (
                      <StoryblokImage
                        sizes="100vw"
                        resize={{ width: 960 }}
                        image={content.image}
                        layout="fill"
                        alt={name}
                      />
                    )
                  }
                  foregroundImage={
                    isForegroundImage(content) &&
                    isValidImageData(content.image) && (
                      <StoryblokImage
                        sizes="33vw"
                        resize={{ width: 960 }}
                        image={content.image}
                        layout="fill"
                        alt={name}
                      />
                    )
                  }
                  inverted={item.inverted}
                  overlay={item.overlay}
                  buttons={
                    <Button variant="cta" href={resolveSlug(full_slug)}>
                      {t("learn-more")}
                    </Button>
                  }
                  fullWidth={i === 0}
                />
              );
            }
          })}
      </FeaturedContentGridUi>
    );
  } else {
    return <></>;
  }
};

export default FeaturedContentGrid;
